import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  EventEmitter,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { IonItemSliding } from "@ionic/angular";
import { Plant } from "src/model/class/general classes/plant";
import { EventService } from "src/service/event.service";
import { AuthenticationService } from "src/service/authentication.service";
import { AlertService } from "src/service/alert.service";
import { iCredential } from "src/model/interface/icredential";
import { PlantService } from "src/service/plant.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { iTranslation } from "src/components/shared-components/interfaces/iTranslation";
import { SystemRouterService } from "src/service/system-router.service";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { NetworkService } from "src/service/network.service";

@Component({
    selector: "app-plant",
    templateUrl: "./plant.component.html",
    styleUrls: ["./plant.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

/**
 * Plant single entry componet
 */
export class PlantComponent implements OnInit, OnDestroy, iTranslation {
  private _translateSubscription: Subscription = null;

  private _lblDeletePlant = "Cancella impianto";
  private _lblDeletePlantMessage =
    "Sei sicuro di voler cancellare l'impianto selezionato?";
  private _networkServiceSubscription: Subscription = null;
  private _isSliding = false;

  @Input() plant: Plant;
  @Output() checkSliding = new EventEmitter<Boolean>();

  constructor(
    private _eventService: EventService,
    private _plantService: PlantService,
    private _alertService: AlertService,
    private _translateService: TranslateService,
    private _systemRouterService: SystemRouterService,
    private _networkService: NetworkService
  ) {
    //this.translationSub();
  }

  ngOnInit() {
    this.loadTranslation();
    this.subscribeTranslationEvent();
  }

  ngOnDestroy() {
    this._translateSubscription.unsubscribe();
  }

  //#region Translation
  public loadTranslation(): void {
    this._translateService
      .get(["dictionary.deletePlant", "dictionary.deletePlantMsg"])
      .subscribe((translation) => {
        this._lblDeletePlant = translation["dictionary.deletePlant"];
        this._lblDeletePlantMessage = translation["dictionary.deletePlantMsg"];
      });
  }

  public subscribeTranslationEvent() {
    this._translateSubscription = this._translateService.onLangChange.subscribe(
      () => {
        this.loadTranslation();
      }
    );
  }
  //#endregion

  /**
   *
   * @param event dom event ref
   * @param idCurrentPlant id plant clicked
   * @param item item sliding event ref
   *
   * Perform redirect to plant edit page
   *
   */
  public onEditPlant(
    event: any,
    idCurrentPlant: number,
    item: IonItemSliding
  ): void {
    event.stopPropagation();
    event.preventDefault();

    this._systemRouterService.navigateToSpecificPlant(idCurrentPlant);

    item.close();
  }

  /**
   *
   * @param event dom event ref
   * @param idCurrentPlant id plant clicked
   * @param item item sliding event ref
   *
   * Perform plant deleting, after user request confirm
   */
  public async onDeletePlant(
    event,
    idCurrentPlant: number,
    item: IonItemSliding
  ): Promise<void> {
    this._isSliding = false;
    this.checkSliding.emit(this._isSliding);
    event.stopPropagation();

    try {
      const cancelOperation: boolean =
        await this._alertService.presentAlertConfirmOrDismiss(
          this._lblDeletePlant,
          "",
          this._lblDeletePlantMessage
        );

      if (cancelOperation) {
        this._plantService.removePlant(this.plant.ID);
      }
    } catch (exception) {
      await this._alertService.presentAlertSomethingWrong();
    } finally {
      item.close();
    }
  }

  /**
   * Check if an item has been scrolled
   * @param event
   */
  public handleSlide(event) {
    event.target.getSlidingRatio().then((res) => {
      if (res >= 1) {
        this._isSliding = true;
      } else {
        this._isSliding = false;
      }
      this.checkSliding.emit(this._isSliding);
    });
  }

  /**
   *
   * @param currentPlant current clicked plants
   *
   * Perform click plant event: it redirect to login access form
   */
  public onClickPlant(currentPlant: Plant): void {
    this._eventService.OnSelectPlantShowLoginForm.next(currentPlant);
  }
}
